import { ApolloClient, from, HttpLink, InMemoryCache, split } from '@apollo/client';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { refreshAccessToken } from '../api/authApi';
import store from '../../redux/store';
import progressMagicJwtToken from '../../config/constants';
import { logout } from '../../redux/GlobalAction';

const httpLink = new HttpLink({
  uri: `${process.env.REACT_APP_GRAPHQL_ENDPOINT}`,
});

const wsLink = new WebSocketLink({
  uri: `${process.env.REACT_APP_WS_ENDPOINT}`,
  options: {
    reconnect: true,
    lazy: true,
    connectionParams: () => ({
      authorization: `Bearer ${localStorage.getItem(progressMagicJwtToken)}`,
    }),
  },
});

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
  },
}));

// Log any GraphQL errors or network error that occurred
const errorLink = onError(({ graphQLErrors, networkError: _networkError, operation, forward }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(async ({ message, locations: _locations, path: _path }) => {
      if (message === 'Unauthorized') {
        const { accessToken } = await refreshAccessToken();
        operation.setContext(({ headers = {} }) => ({
          headers: {
            ...headers,
            authorization: accessToken ? `Bearer ${accessToken}` : '',
          },
        }));
      }
      if (message === 'Forbidden resource') {
        // Dispatch the logout action or handle the forbidden resource error here
        store.dispatch(logout());
      }
    });
  }

  return forward(operation);
});

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  wsLink,
  from([errorLink, authLink.concat(httpLink)])
);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only',
    },
  },
});

export default client;
